import { graphql } from 'gql';

export const uerWorkOrderActsKC2RegistryGql = graphql(`
    query uerWorkOrderActsKC2Registry(
        $workOrderId: Long!
        $groupType: ActKC2GroupTypeEnum
        $where: ActKC2ListItemDataFilterInput
        $order: [ActKC2ListItemDataSortInput!]
    ) {
        uerWorkOrderActsKC2Registry(workOrderId: $workOrderId, groupType: $groupType, where: $where, order: $order) {
            items {
                actKC2Id
                number
                groupId
                groupUniqueId
                groupName
                groupCount
                status
                actDate
                actYear
                actMonth
                startDate
                finishDate
                costGroup
                constructionTypeId
                constructionType {
                    id
                    code
                    name
                    fullName
                    shortName
                    contractFileName
                    catalogId
                    createdAt
                    uniqueId
                }
                workOrderObjectId
                workOrderObjectName
                costWithoutTax
                isIncluded
                groupCostWithoutTax
                isCorrection
                isInactive
                fullNumber
                correctionDate
                correctionNumber
                statusSKzS
            }
            totalCount
        }
    }
`);

export const uerWorkOrderActsKC2SelectionListGql = graphql(`
    query uerWorkOrderActsKC2RegistrySelectionList($workOrderId: Long!, $actKC2GroupId: Long) {
        uerWorkOrderActsKC2RegistrySelectionList(workOrderId: $workOrderId, actKC2GroupId: $actKC2GroupId) {
            totalCount
            items {
                groupId
                actKC2Id
                groupName
                number
                actDate
                startDate
                finishDate
                costGroup
                constructionType {
                    id
                    code
                    name
                    fullName
                    shortName
                    contractFileName
                    catalogId
                    createdAt
                    uniqueId
                }
                workOrderObjectName
                costWithoutTax
                isIncluded
                status
            }
        }
    }
`);

export const uerCreateWorkOrderActsKC2GroupGql = graphql(`
    mutation uerCreateWorkOrderActsKC2Group($workOrderId: Long!, $input: ActKC2GroupInput!) {
        uerCreateWorkOrderActsKC2Group(workOrderId: $workOrderId, input: $input) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateWorkOrderActsKC2GroupGql = graphql(`
    mutation uerUpdateWorkOrderActsKC2Group($actKC2GroupId: Long!, $input: ActKC2GroupInput!) {
        uerUpdateWorkOrderActsKC2Group(actKC2GroupId: $actKC2GroupId, input: $input) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerRemoveWorkOrderActsKC2GroupGql = graphql(`
    mutation uerRemoveWorkOrderActsKC2Group($actKC2GroupId: Long!) {
        uerRemoveWorkOrderActsKC2Group(actKC2GroupId: $actKC2GroupId) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerActKC2GroupNumberFilterGql = graphql(`
    query uerActKC2GroupNumberFilter($workOrderId: Long!, $where: FilterValueOfStringFilterInput) {
        uerActKC2GroupNumberFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const uerActKC2GroupDateFilterGql = graphql(`
    query uerActKC2GroupDateFilter($workOrderId: Long!, $where: FilterValueOfNullableOfDateOnlyFilterInput) {
        uerActKC2GroupDateFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const uerActKC2GroupCostGroupFilterGql = graphql(`
    query uerActKC2GroupCostGroupFilter($workOrderId: Long!, $where: FilterValueOfCostGroupEnumFilterInput) {
        uerActKC2GroupCostGroupFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const uerActKC2GroupConstructionTypeFilterGql = graphql(`
    query uerActKC2GroupConstructionTypeFilter($workOrderId: Long!, $where: FilterValueOfStringFilterInput) {
        uerActKC2GroupConstructionTypeFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);
export const uerActKC2GroupObjectFilterGql = graphql(`
    query uerActKC2GroupObjectFilter($workOrderId: Long!, $where: FilterValueOfStringFilterInput) {
        uerActKC2GroupObjectFilter(workOrderId: $workOrderId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const uerIsUniqueActKC2GroupNameGql = graphql(`
    query uerIsUniqueActKC2GroupName($workOrderId: Long!, $groupName: String!, $actKC2GroupId: Long) {
        uerIsUniqueActKC2GroupName(workOrderId: $workOrderId, groupName: $groupName, actKC2GroupId: $actKC2GroupId) {
            buttonText
            code
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
